import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import DrawerComponent from "../../common/DrawerComponent";
import ReferralTab from "./ReferralTab";
import RewardsTab from "./RewardsTab";
import styles from "./styles.module.scss";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
import Button from "../../common/Button";
import GainfulToggle from "../GainfulToggle";
const RewardsActionsDrawer = ({ toggleDrawer, openDrawer, rewardsOpen, actionHistory, referAFriend, }) => {
    const [tabs, setTabs] = useState({
        rewards: rewardsOpen,
        referral: !rewardsOpen,
    });
    const isMobile = useScreenWidth() < 900;
    const closeOpenDrawer = (value) => () => {
        toggleDrawer(value)();
    };
    const changeTab = (name) => {
        const defaultTab = {
            rewards: false,
            referral: false,
        };
        setTabs({ ...defaultTab, [name]: true });
    };
    useEffect(() => {
        setTabs({ rewards: rewardsOpen, referral: !rewardsOpen });
    }, [rewardsOpen]);
    return (_jsxs(DrawerComponent, { crossButton: true, open: openDrawer, toggleDrawer: closeOpenDrawer, anchor: isMobile ? "bottom" : "right", extraClassName: styles.modify_order_header, hideZendeskIcon: true, children: [_jsxs("div", { className: styles.wrapper, children: [_jsx("h1", { className: styles.title, children: "Referrals" }), _jsx("p", { children: "Note: One discount can be redeemed per order. See terms for details." }), _jsx(GainfulToggle, { text: ["Referral Credit", "Referral History"], callbacks: [() => changeTab("rewards"), () => changeTab("referral")] }), tabs.referral ? _jsx(RewardsTab, { data: actionHistory || [] }) : _jsx(ReferralTab, {})] }), _jsx("div", { className: styles.center, children: _jsx(Button, { color: "green", onClick: closeOpenDrawer(false), children: "Refer a Friend" }) })] }));
};
export default RewardsActionsDrawer;
